export default __webpack_public_path__ + "static/media/no-image.3c8a503e.jpg";